import { map, filter, reduce } from 'lodash';
import { fetchContractPdf, sendPDFSToEmails, getRecurringPaymentsSummary } from '../../api/pdfApi';
import {
  fetchPaymentReceipt,
  getPayUrl,
  makeBindingTransaction,
  deactivateCardBinding,
  fetchSavedCards,
  postFreePayment,
  makeCardAsDefault,
  getAddNewCardUrl,
  getAutomaticRecurringPaymentScheduleByToken,
  getFailedRecurringPayments,
  retryRecurringPayment,
  recurringPaymentFutureNotifications,
  getRecurringPaymentAttempts,
} from '../../api/paymentApi';
import { fetchFromCacheById, saveRecurringPaymentInCacheAPI } from '../../api/cacheApi';
import { bulkUpdateBasket } from './basketReducer';
import { ATTACH_PAYMENT_CARD_OPTIONS, PAYMENT_METHOD } from '../../constants';
import { getContract } from './recPayment';

const GET_PAYMENT_URL = 'efes/payment/GET_PAYMENT_URL';
const GET_PAYMENT_URL_SUCCESS = 'efes/payment/GET_PAYMENT_URL_SUCCESS';
const GET_PAYMENT_URL_FAIL = 'efes/payment/GET_PAYMENT_URL_FAIL';

const SEND_EMAILS = 'efes/payment/SEND_EMAILS';
const SEND_EMAILS_SUCCESS = 'efes/payment/SEND_EMAILS_SUCCESS';
const SEND_EMAILS_FAIL = 'efes/payment/SEND_EMAILS_FAIL';

const GET_CONTRACT_PDF = 'efes/payment/GET_CONTRACT_PDF';
const GET_CONTRACT_PDF_SUCCESS = 'efes/payment/GET_CONTRACT_PDF_SUCCESS';
const GET_CONTRACT_PDF_FAIL = 'efes/payment/GET_CONTRACT_PDF_FAIL';

const GET_PAYMENT_RECEIPT = 'efes/payment/GET_PAYMENT_RECEIPT';
const GET_PAYMENT_RECEIPT_SUCCESS = 'efes/payment/GET_PAYMENT_RECEIPT_SUCCESS';
const GET_PAYMENT_RECEIPT_FAIL = 'efes/payment/GET_PAYMENT_RECEIPT_FAIL';

const GET_TRAVEL_RECURRING_PAYMENT = 'efes/payment/GET_TRAVEL_RECURRING_PAYMENT';
const GET_TRAVEL_RECURRING_PAYMENT_SUCCESS = 'efes/payment/GET_TRAVEL_RECURRING_PAYMENT_SUCCESS';
const GET_TRAVEL_RECURRING_PAYMENT_FAIL = 'efes/payment/GET_TRAVEL_RECURRING_PAYMENT_FAIL';

const SET_RECURRING_PAYMENT_SUMMARIES = 'efes/payment/SET_RECURRING_PAYMENT_SUMMARIES';

const SET_PAYER_CONTACT_INFO = 'efes/payment/SET_PAYER_CONTACT_INFO';
const SET_SAVE_CARD = 'efes/payment/SET_SAVE_CARD';

const SAVE_RECURRING_PAYMENT_IN_CACHE = 'efes/payment/SAVE_RECURRING_PAYMENT_IN_CACHE';
const SAVE_RECURRING_PAYMENT_IN_CACHE_SUCCESS = 'efes/payment/SAVE_RECURRING_PAYMENT_IN_CACHE_SUCCESS';
const SAVE_RECURRING_PAYMENT_IN_CACHE_FAIL = 'efes/payment/SAVE_RECURRING_PAYMENT_IN_CACHE_FAIL';

const SET_RECURRING_PAYMENT_METHOD = 'efes/payment/SET_RECURRING_PAYMENT_METHOD';

const RECOVER_RECURRING_PAYMENT_FROM_CACHE = 'efes/payment/RECOVER_RECURRING_PAYMENT_FROM_CACHE';
const RECOVER_RECURRING_PAYMENT_FROM_CACHE_SUCCESS = 'efes/payment/RECOVER_RECURRING_PAYMENT_FROM_CACHE_SUCCESS';
const RECOVER_RECURRING_PAYMENT_FROM_CACHE_FAIL = 'efes/payment/RECOVER_RECURRING_PAYMENT_FROM_CACHE_FAIL';

const PAYMENT_IN_PROGRESS = 'efes/payment/SET_PAYING_IN_PROGRESS';
const PAYMENT_IN_PROGRESS_SUCCESS = 'efes/payment/PAYMENT_IN_PROGRESS_SUCCESS';
const PAYMENT_IN_PROGRESS_FAIL = 'efes/payment/PAYMENT_IN_PROGRESS_FAIL';

const GET_SAVED_CARDS = 'efes/payment/GET_SAVED_CARDS';
const GET_SAVED_CARDS_SUCCESS = 'efes/payment/GET_SAVED_CARDS_SUCCESS';
const GET_SAVED_CARDS_FAIL = 'efes/payment/GET_SAVED_CARDS_FAIL';

const MAKE_BINDING_TRANSACTION = 'efes/payment/MAKE_BINDING_TRANSACTION';
const MAKE_BINDING_TRANSACTION_SUCCESS = 'efes/payment/MAKE_BINDING_TRANSACTION_SUCCESS';
const MAKE_BINDING_TRANSACTION_FAIL = 'efes/payment/MAKE_BINDING_TRANSACTION_FAIL';

const DEACTIVATE_BINDING = 'efes/payment/DEACTIVATE_BINDING';
const DEACTIVATE_BINDING_SUCCESS = 'efes/payment/DEACTIVATE_BINDING_SUCCESS';
const DEACTIVATE_BINDING_FAIL = 'efes/payment/DEACTIVATE_BINDING_FAIL';

const MAKE_DEFAULT = 'efes/payment/MAKE_DEFAULT';
const MAKE_DEFAULT_SUCCESS = 'efes/payment/MAKE_DEFAULT_SUCCESS';
const MAKE_DEFAULT_FAIL = 'efes/payment/MAKE_DEFAULT_FAIL';

const ADD_NEW_CARD = 'efes/payment/ADD_NEW_CARD';
const ADD_NEW_CARD_SUCCESS = 'efes/payment/ADD_NEW_CARD_SUCCESS';
const ADD_NEW_CARD_FAIL = 'efes/payment/ADD_NEW_CARD_FAIL';

const MAKE_FREE_PAYMENT = 'efes/payment/MAKE_FREE_PAYMENT';
const MAKE_FREE_PAYMENT_SUCCESS = 'efes/payment/MAKE_FREE_PAYMENT_SUCCESS';
const MAKE_FREE_PAYMENT_FAIL = 'efes/payment/MAKE_FREE_PAYMENT_FAIL';

const GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN = 'efes/payment/GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN';
const GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN_SUCCESS = 'efes/payment/GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN_SUCCESS';
const GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN_FAIL = 'efes/payment/GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN_FAIL';

const GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS = 'efes/payment/AUTOMATIC_RECURRING_PAYMENTS';
const GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS_SUCCESS = 'efes/payment/GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS_SUCCESS';
const GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS_FAIL = 'efes/payment/GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS_FAIL';

const RETRY_AUTOMATIC_RECURRING_PAYMENT = 'efes/payment/RETRY_AUTOMATIC_RECURRING_PAYMENT';
const RETRY_AUTOMATIC_RECURRING_PAYMENT_SUCCESS = 'efes/payment/RETRY_AUTOMATIC_RECURRING_PAYMENT_SUCCESS';
const RETRY_AUTOMATIC_RECURRING_PAYMENT_FAIL = 'efes/payment/RETRY_AUTOMATIC_RECURRING_PAYMENT_FAIL';

const DISABLE_AUTOMATIC_RECURRING_PAYMENT_ROW = 'efes/payment/DISABLE_AUTOMATIC_RECURRING_PAYMENT_ROW';

const GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS = 'efes/payment/GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS';
const GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS_SUCCESS = 'efes/payment/GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS_SUCCESS';
const GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS_FAIL = 'efes/payment/GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS_FAIL';

const GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS = 'efes/payment/GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS';
const GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS_SUCCESS = 'efes/payment/GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS_SUCCESS';
const GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS_FAIL = 'efes/payment/GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS_FAIL';

const SET_ATTACH_CARD_AGREEMENT = 'efes/payment/SET_ATTACH_CARD_AGREEMENT';

const initialState = {
  data: null,
  pdf: [],
  receipt: null,
  loadingPdf: false,
  sendingEmail: false,
  contractPdfError: null,
  sendingEmailError: null,
  gettingPaymentUrl: false,
  loadingRecurringPayments: false,
  travelRecurringPayments: [],
  recurringPaymentsSummaries: null,
  recurringPayment: null,
  saveCard: false,
  agreement: false,
  payerContactInfo: {
    isInsured: true,
    isPhoneDefault: true,
    isEmailDefault: true,
    firstName: '',
    lastName: '',
    mobilePhone: '',
    email: '',
    emailConfirm: '',
  },
  recurringPaymentMethod: PAYMENT_METHOD.CARD,
  recoveringRecurringPayment: false,
  payingInProgress: false,
  transactionBinding: {
    isLoading: false,
    savedCards: [],
    successRedirectUrl: '',
  },
  freePaymentSuccessRedirectUrl: '',
  recurringPaymentSchedule: {
    isLoading: true,
    data: {},
  },
  failedAutomaticRecurringPayments: {
    data: [],
    loading: false,
  },
  automaticRecurringFutureNotifications: {
    data: [],
    total: 0,
    loading: false,
  },
  paymentAttempts: {
    data: [],
    total: 0,
    isLoading: false,
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CONTRACT_PDF:
      return {
        ...state,
        contractPdfError: null,
        loadingPdf: true,
      };
    case GET_CONTRACT_PDF_SUCCESS:
      return {
        ...state,
        loadingPdf: false,
        pdf: action.result,
      };
    case GET_CONTRACT_PDF_FAIL:
      return {
        ...state,
        loadingPdf: false,
        contractPdfError: action.error,
      };
    case SEND_EMAILS:
      return {
        ...state,
        sendingEmail: true,
        sendingEmailError: null,
      };
    case SEND_EMAILS_SUCCESS:
      return {
        ...state,
        sendingEmail: false,
      };
    case SEND_EMAILS_FAIL:
      return {
        ...state,
        sendingEmail: false,
        sendingEmailError: action.error,
      };
    case GET_PAYMENT_URL:
      return {
        ...state,
        gettingPaymentUrl: true,
      };
    case GET_PAYMENT_URL_SUCCESS:
    case GET_PAYMENT_URL_FAIL:
      return {
        ...state,
        gettingPaymentUrl: false,
      };
    case GET_PAYMENT_RECEIPT:
      return {
        ...state,
        receiptError: null,
        loadingReceipt: true,
      };
    case GET_PAYMENT_RECEIPT_SUCCESS:
      return {
        ...state,
        loadingReceipt: false,
        receipt: action.result,
      };
    case GET_PAYMENT_RECEIPT_FAIL:
      return {
        ...state,
        loadingReceipt: false,
        receiptError: action.error,
      };
    case GET_TRAVEL_RECURRING_PAYMENT:
      return {
        ...state,
        loadingRecurringPayments: true,
        travelRecurringPayments: [],
      };
    case GET_TRAVEL_RECURRING_PAYMENT_SUCCESS:
      return {
        ...state,
        loadingRecurringPayments: false,
        travelRecurringPayments: action.result,
      };
    case GET_TRAVEL_RECURRING_PAYMENT_FAIL:
      return {
        ...state,
        loadingRecurringPayments: false,
        travelRecurringPayments: [],
      };
    case SET_RECURRING_PAYMENT_SUMMARIES:
      return {
        ...state,
        recurringPaymentsSummaries: action.result,
      };
    case SET_PAYER_CONTACT_INFO:
      return {
        ...state,
        payerContactInfo: {
          ...state.payerContactInfo,
          ...action.result,
        },
      };
    case SET_SAVE_CARD:
      return {
        ...state,
        saveCard: action.result,
      };
    case SET_RECURRING_PAYMENT_METHOD:
      return {
        ...state,
        recurringPaymentMethod: action.result,
      };
    case RECOVER_RECURRING_PAYMENT_FROM_CACHE:
      return {
        ...state,
        recoveringRecurringPayment: true,
      };
    case RECOVER_RECURRING_PAYMENT_FROM_CACHE_SUCCESS:
    case RECOVER_RECURRING_PAYMENT_FROM_CACHE_FAIL:
      return {
        ...state,
        recoveringRecurringPayment: false,
      };
    case PAYMENT_IN_PROGRESS:
      return {
        ...state,
        payingInProgress: true,
      };
    case PAYMENT_IN_PROGRESS_SUCCESS:
    case PAYMENT_IN_PROGRESS_FAIL:
      return {
        ...state,
        payingInProgress: false,
      };
    case SAVE_RECURRING_PAYMENT_IN_CACHE:
      return {
        ...state,
        savingRecurringPayment: true,
        orderId: null,
      };
    case SAVE_RECURRING_PAYMENT_IN_CACHE_SUCCESS:
      return {
        ...state,
        savingRecurringPayment: false,
        orderId: action.result.id,
      };
    case SAVE_RECURRING_PAYMENT_IN_CACHE_FAIL:
      return {
        ...state,
        savingRecurringPayment: false,
        orderId: null,
      };
    case GET_SAVED_CARDS:
    case MAKE_BINDING_TRANSACTION:
    case DEACTIVATE_BINDING:
    case MAKE_DEFAULT:
    case ADD_NEW_CARD:
      return {
        ...state,
        transactionBinding: {
          ...state.transactionBinding,
          isLoading: true,
        },
      };
    case GET_SAVED_CARDS_SUCCESS:
      return {
        ...state,
        transactionBinding: {
          ...state.transactionBinding,
          isLoading: false,
          savedCards: action.result,
        },
      };
    case GET_SAVED_CARDS_FAIL:
    case MAKE_BINDING_TRANSACTION_FAIL:
    case DEACTIVATE_BINDING_SUCCESS:
    case DEACTIVATE_BINDING_FAIL:
    case MAKE_DEFAULT_SUCCESS:
    case MAKE_DEFAULT_FAIL:
    case ADD_NEW_CARD_SUCCESS:
    case ADD_NEW_CARD_FAIL:
      return {
        ...state,
        transactionBinding: {
          ...state.transactionBinding,
          isLoading: false,
        },
      };
    case MAKE_BINDING_TRANSACTION_SUCCESS:
      return {
        ...state,
        transactionBinding: {
          ...state.transactionBinding,
          isLoading: false,
          successRedirectUrl: action.result.url,
        },
      };

    case MAKE_FREE_PAYMENT:
      return {
        ...state,
        transactionBinding: { ...state.transactionBinding, isLoading: true },
      };
    case MAKE_FREE_PAYMENT_SUCCESS:
      return {
        ...state,
        freePaymentSuccessRedirectUrl: action.result.url,
      };
    case MAKE_FREE_PAYMENT_FAIL:
      return {
        ...state,
        transactionBinding: { ...state.transactionBinding, isLoading: false },
      };

    case GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN:
      return {
        ...state,
        recurringPaymentSchedule: {
          isLoading: true,
          data: {},
        },
      };
    case GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN_SUCCESS:
      return {
        ...state,
        recurringPaymentSchedule: {
          isLoading: false,
          data: action.result,
        },
      };
    case GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN_FAIL:
      return {
        ...state,
        recurringPaymentSchedule: {
          isLoading: true,
          data: {},
        },
      };
    case GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS:
      return {
        ...state,
        failedAutomaticRecurringPayments: {
          data: [],
          total: 0,
          loading: true,
        },
      };
    case GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS_SUCCESS: {
      const { data, total } = action.result;
      return {
        ...state,
        failedAutomaticRecurringPayments: {
          data,
          total,
          loading: false,
        },
      };
    }
    case GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS_FAIL:
      return {
        ...state,
        failedAutomaticRecurringPayments: {
          data: [],
          total: 0,
          loading: true,
        },
      };
    case GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS:
      return {
        ...state,
        paymentAttempts: {
          data: [],
          total: 0,
          isLoading: true,
        },
      };
    case GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS_SUCCESS: {
      const { data, total } = action.result;
      return {
        ...state,
        paymentAttempts: {
          data,
          total,
          isLoading: false,
        },
      };
    }
    case GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS_FAIL:
      return {
        ...state,
        paymentAttempts: {
          data: [],
          total: 0,
          isLoading: true,
        },
      };
    case RETRY_AUTOMATIC_RECURRING_PAYMENT:
      return state;
    // These brackets put to fixing {eslint: no-case-declaration}
    case RETRY_AUTOMATIC_RECURRING_PAYMENT_SUCCESS: {
      const filteredPayments = state.failedAutomaticRecurringPayments.data.filter(
        (item) => item.id !== action.result.id,
      );
      return {
        ...state,
        failedAutomaticRecurringPayments: {
          data: filteredPayments,
        },
      };
    }
    case RETRY_AUTOMATIC_RECURRING_PAYMENT_FAIL:
      return state;

    case DISABLE_AUTOMATIC_RECURRING_PAYMENT_ROW: {
      const filteredPayments = state.failedAutomaticRecurringPayments.data.map((item) => {
        if (item.id === action.id) {
          return {
            ...item,
            isDisabled: true,
          };
        }
        return {
          ...item,
        };
      });
      return {
        ...state,
        failedAutomaticRecurringPayments: {
          data: filteredPayments,
        },
      };
    }
    case GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS:
      return {
        ...state,
        automaticRecurringFutureNotifications: {
          data: [],
          total: 0,
          loading: true,
        },
      };
    case GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS_SUCCESS: {
      const { data, total } = action.result;
      return {
        ...state,
        automaticRecurringFutureNotifications: {
          data,
          total,
          loading: false,
        },
      };
    }
    case GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS_FAIL:
      return {
        ...state,
        automaticRecurringFutureNotifications: {
          data: [],
          loading: true,
        },
      };
    case SET_ATTACH_CARD_AGREEMENT:
      return {
        ...state,
        agreement: action.result,
      };
    default:
      return state;
  }
}

export const getContractPdf = (type, token) => ({
  actions: [
    { type: GET_CONTRACT_PDF },
    { type: GET_CONTRACT_PDF_SUCCESS },
    { type: GET_CONTRACT_PDF_FAIL },
  ],
  promise: fetchContractPdf(type, token),
});

export const getPaymentReceipt = (paymentData) => ({
  actions: [
    { type: GET_PAYMENT_RECEIPT },
    { type: GET_PAYMENT_RECEIPT_SUCCESS },
    { type: GET_PAYMENT_RECEIPT_FAIL },
  ],
  promise: fetchPaymentReceipt(paymentData),
});

export const sendEmails = (id, emailList) => ({
  actions: [
    { type: SEND_EMAILS },
    { type: SEND_EMAILS_SUCCESS, showSuccess: true },
    { type: SEND_EMAILS_FAIL, showError: true, customMsg: 'emailFailed' },
  ],
  promise: sendPDFSToEmails(id, emailList),
});

export function getPaymentUrl(orderId, paymentType, savePaymentType, isAutomaticRecurringPayment) {
  return {
    actions: [
      { type: GET_PAYMENT_URL },
      { type: GET_PAYMENT_URL_SUCCESS },
      {
        type: GET_PAYMENT_URL_FAIL,
        showError: true,
        customMsg: 'contactAgent',
      },
    ],
    promise: getPayUrl(orderId, paymentType, savePaymentType, isAutomaticRecurringPayment),
  };
}

const getAttachNewCardURL = (subscriptionType, orderId, policyNumber) => ({
  actions: [
    { type: GET_PAYMENT_URL },
    { type: GET_PAYMENT_URL_SUCCESS },
    {
      type: GET_PAYMENT_URL_FAIL,
      showError: true,
      customMsg: 'contactAgent',
    },
  ],
  promise: getAddNewCardUrl(subscriptionType, orderId, policyNumber),
});

export const setAgreement = (attachCardAgreement) => ({
  type: SET_ATTACH_CARD_AGREEMENT,
  result: attachCardAgreement,
});

export function makePayment(
  orderId,
  paymentType,
  draftToken,
  savePaymentType = false,
  isAutomaticRecurringPayment = false,
) {
  return (dispatch) => dispatch(
    getPaymentUrl(orderId, paymentType, savePaymentType, isAutomaticRecurringPayment),
  ).then(
    (paymentUrl) => {
      // before navigating to payment page adding  hash
      // to be able to recover app state on back navigation;
      window.location.hash = `bfp=true&orderId=${orderId}&draftToken=${draftToken}&paymentType=${paymentType}`;
      window.location.href = paymentUrl;
    },
    () => {},
  );
}

export function attach(
  subscriptionType,
  orderId,
  policyNumber,
) {
  return (dispatch) => dispatch(
    getAttachNewCardURL(subscriptionType, orderId, policyNumber),
  ).then(
    (paymentUrl) => {
      window.location.hash = `bfp=true&orderId=${orderId}`;
      window.location.href = paymentUrl;
    },
    () => {},
  );
}

export function setRecurringPaymentsSummaries(summaries) {
  return {
    type: SET_RECURRING_PAYMENT_SUMMARIES,
    result: summaries,
  };
}

function isBalancePositive(payment) {
  return Number(payment.balance) > 0;
}

function getAllUpcomingPayments(payments) {
  return filter(payments, (p) => isBalancePositive(p));
}

function fullBalance(payments) {
  return reduce(payments, (sum, p) => sum + Number(p.balance), 0).toFixed(2);
}

export function getTravelRecurringPayments(ids, amounts, billingNumber) {
  const summaries = [];
  const recurringPayments = map(ids, (id, index) => getRecurringPaymentsSummary({
    policy_number: id,
    type: 'travel',
  }).then((res) => {
    const payments = res.result.result.payment;
    const upcomingPayments = getAllUpcomingPayments(payments);
    // since it takes hours to process it. So we pick the 2nd item
    const nextPayment = upcomingPayments[1] || {};
    const amount = amounts[index];
    const summary = {
      contractNumber: id,
      paid: amount,
      balance: fullBalance(payments) - amount,
      nextPaymentDate: nextPayment.date,
      billingNumber,
    };
    summaries.push(summary);
  }));

  return (dispatch) => ({
    actions: [
      { type: GET_TRAVEL_RECURRING_PAYMENT },
      { type: GET_TRAVEL_RECURRING_PAYMENT_SUCCESS },
      { type: GET_TRAVEL_RECURRING_PAYMENT_FAIL },
    ],
    promise: Promise.all(recurringPayments).then(() => {
      dispatch(setRecurringPaymentsSummaries(summaries));
    }),
  });
}

export const setPayerContactInfo = (data) => ({
  type: SET_PAYER_CONTACT_INFO,
  result: data,
});

export const setSaveCard = (data) => ({
  type: SET_SAVE_CARD,
  result: data,
});

export function getDraftPayment(id) {
  return (dispatch) => fetchFromCacheById(id).then((data) => {
    const {
      email,
      firstName,
      lastName,
      mobilePhone,
      isInsured,
      isPhoneDefault,
      isEmailDefault,
      basket,
      attachCardAgreement,
      contractId,
    } = data;
    dispatch(setAgreement(attachCardAgreement));
    if (attachCardAgreement) {
      dispatch(getContract({ policyNumber: contractId[0] }));
    }
    dispatch(setPayerContactInfo(
      {
        email,
        emailConfirm: email,
        firstName,
        lastName,
        mobilePhone,
        isInsured,
        isPhoneDefault,
        isEmailDefault,
      },
    ));
    dispatch(bulkUpdateBasket(basket));
  });
}

export function saveRecurringPaymentInCache(recurringPayment) {
  return {
    actions: [
      { type: SAVE_RECURRING_PAYMENT_IN_CACHE },
      { type: SAVE_RECURRING_PAYMENT_IN_CACHE_SUCCESS },
      { type: SAVE_RECURRING_PAYMENT_IN_CACHE_FAIL, showError: true },
    ],
    promise: saveRecurringPaymentInCacheAPI(recurringPayment),
  };
}

export const setRecurringPaymentMethod = (result) => ({
  type: SET_RECURRING_PAYMENT_METHOD,
  result,
});

export function recoverRecurringPayment(orderId, paymentType) {
  return (dispatch) => {
    dispatch({ type: RECOVER_RECURRING_PAYMENT_FROM_CACHE });
    dispatch(setRecurringPaymentMethod(paymentType));
    return dispatch(getDraftPayment(orderId))
      .then(() => {
        dispatch({ type: RECOVER_RECURRING_PAYMENT_FROM_CACHE_SUCCESS });
      })
      .catch(() => {
        dispatch({ type: RECOVER_RECURRING_PAYMENT_FROM_CACHE_FAIL });
      });
  };
}

const composePayableSchedule = (policies) => {
  const result = [];
  policies.forEach((policy) => {
    const { policyNumber, tableRows } = policy;
    const lastIndex = tableRows.findIndex((row) => row.isLastChecked);
    const filteredRows = tableRows.filter((row, index) => index <= lastIndex && !row.isDisabled);
    result.push({
      policyNumber,
      rows: filteredRows,
    });
  });
  return result;
};

const getPayment = (getStore) => {
  const { payerContactInfo } = getStore().paymentReducer;
  const { basket } = getStore().basketReducer;
  const payableSchedule = composePayableSchedule(basket);
  const recPayment = reduce(
    basket,
    (result, value) => {
      result.contractId.push(value.policyNumber);
      result.amount.push(value.totalAndBalance.selectedToPay);
      return result;
    },
    { contractId: [], amount: [] },
  );
  return { ...payerContactInfo, ...recPayment, payableSchedule, type: 'recurring-payment', basket };
};

const getAttachCardPayment = (getStore) => {
  const { payerContactInfo } = getStore().paymentReducer;
  const { basket } = getStore().basketReducer;
  const payableSchedule = composePayableSchedule(basket);
  const recPayment = reduce(
    basket,
    (result, value) => {
      result.contractId.push(value.policyNumber);
      result.amount.push(value.totalAndBalance.selectedToPay);
      return result;
    },
    { contractId: [], amount: [] },
  );
  return { ...payerContactInfo, ...recPayment, payableSchedule, type: ATTACH_PAYMENT_CARD_OPTIONS.ATTACH_EXISTING_RECURRING_CONTRACT_CARD, basket };
};

export function addPayerAndSaveInCache(payer) {
  return (dispatch, getStore) => {
    dispatch(setPayerContactInfo(payer));
    const payment = getPayment(getStore);
    return dispatch(saveRecurringPaymentInCache({ ...payment }));
  };
}

export function addAttachCardPayerAndSaveInCache(payer) {
  return (dispatch, getStore) => {
    dispatch(setPayerContactInfo(payer));
    const payment = getAttachCardPayment(getStore);
    return dispatch(saveRecurringPaymentInCache({ ...payment, attachCardAgreement: payer.attachCardAgreement }));
  };
}

export function pay(shouldSaveCard = false) {
  return (dispatch, getStore) => {
    dispatch({ type: PAYMENT_IN_PROGRESS });
    const { recurringPaymentMethod, orderId } = getStore().paymentReducer;
    return dispatch(makePayment(orderId, recurringPaymentMethod, null, shouldSaveCard))
      .then(() => {
        dispatch({ type: PAYMENT_IN_PROGRESS_SUCCESS });
      })
      .catch(() => {
        dispatch({ type: PAYMENT_IN_PROGRESS_FAIL });
      });
  };
}

export function attachNewCard(subscriptionType) {
  return (dispatch, getStore) => {
    dispatch({ type: ADD_NEW_CARD });
    const { orderId } = getStore().paymentReducer;
    const { basket } = getStore().basketReducer;
    return dispatch(attach(subscriptionType, orderId, basket[0].policyNumber))
      .then(() => {
        dispatch({ type: ADD_NEW_CARD_SUCCESS });
      })
      .catch(() => {
        dispatch({ type: ADD_NEW_CARD_FAIL });
      });
  };
}

export function tryToPayAgain() {
  return (dispatch, getStore) => {
    const payment = getPayment(getStore);
    return dispatch(saveRecurringPaymentInCache(payment))
      .then(() => {
        dispatch(pay());
      })
      .catch(() => {
        dispatch({ type: SAVE_RECURRING_PAYMENT_IN_CACHE_FAIL });
      });
  };
}

export const getSavedCards = () => ({
  actions: [
    { type: GET_SAVED_CARDS },
    { type: GET_SAVED_CARDS_SUCCESS },
    { type: GET_SAVED_CARDS_FAIL },
  ],
  promise: fetchSavedCards(),
});

export function makeBindingPayment(orderId, cardHolderID) {
  return {
    actions: [
      { type: MAKE_BINDING_TRANSACTION },
      { type: MAKE_BINDING_TRANSACTION_SUCCESS },
      { type: MAKE_BINDING_TRANSACTION_FAIL, showError: true },
    ],
    promise: makeBindingTransaction(orderId, cardHolderID),
  };
}

export function deactivateBinding(cardHolderID) {
  return {
    actions: [
      { type: DEACTIVATE_BINDING },
      { type: DEACTIVATE_BINDING_SUCCESS },
      { type: DEACTIVATE_BINDING_FAIL, showError: true },
    ],
    promise: deactivateCardBinding(cardHolderID),
  };
}

export function makeCardDefault(cardHolderID) {
  return {
    actions: [
      { type: MAKE_DEFAULT },
      { type: MAKE_DEFAULT_SUCCESS },
      { type: MAKE_DEFAULT_FAIL, showError: true },
    ],
    promise: makeCardAsDefault(cardHolderID),
  };
}

export function deactivateBindingAndGetSavedCards(cardHolderID) {
  return (dispatch) => dispatch(deactivateBinding(cardHolderID)).then(
    () => dispatch(getSavedCards()),
    () => {},
  );
}

export function makeCardDefaultAndGetSavedCards(cardHolderID) {
  return (dispatch) => dispatch(makeCardDefault(cardHolderID)).then(
    () => dispatch(getSavedCards()),
    () => {},
  );
}

export function makeFreePayment(orderId) {
  return {
    actions: [
      { type: MAKE_FREE_PAYMENT },
      { type: MAKE_FREE_PAYMENT_SUCCESS },
      { type: MAKE_FREE_PAYMENT_FAIL, showError: true },
    ],
    promise: postFreePayment(orderId),
  };
}

export const getRecurringPaymentScheduleByToken = (type, token, order) => ({
  actions: [
    { type: GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN },
    { type: GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN_SUCCESS },
    { type: GET_RECURRING_PAYMENT_SCHEDULE_BY_TOKEN_FAIL },
  ],
  promise: getAutomaticRecurringPaymentScheduleByToken(type, token, order).then(
    (response) => response,
  ),
});

export const getFailedAutomaticRecurringPayments = (params) => ({
  actions: [
    { type: GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS },
    { type: GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS_SUCCESS },
    { type: GET_FAILED_AUTOMATIC_RECURRING_PAYMENTS_FAIL },
  ],
  promise: getFailedRecurringPayments(params).then((response) => response),
});

export const getAutomaticRecurringPaymentAttempts = (params) => ({
  actions: [
    { type: GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS },
    { type: GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS_SUCCESS },
    { type: GET_AUTOMATIC_RECURRING_PAYMENT_ATTEMPTS_FAIL },
  ],
  promise: getRecurringPaymentAttempts(params).then((response) => response),
});

export const retryAutomaticRecurringPayment = (id) => ({
  actions: [
    { type: RETRY_AUTOMATIC_RECURRING_PAYMENT },
    { type: RETRY_AUTOMATIC_RECURRING_PAYMENT_SUCCESS },
    { type: RETRY_AUTOMATIC_RECURRING_PAYMENT_FAIL },
  ],
  promise: retryRecurringPayment(id),
});

export const disableAutomaticRecurringPaymentRaw = (id) => ({
  type: DISABLE_AUTOMATIC_RECURRING_PAYMENT_ROW,
  id,
});

export const getAutomaticRecurringPaymentFutureNotifications = (params) => ({
  actions: [
    { type: GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS },
    { type: GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS_SUCCESS },
    { type: GET_AUTOMATIC_RECURRING_PAYMENT_FUTURE_NOTIFICATIONS_FAIL },
  ],
  promise: recurringPaymentFutureNotifications(params),
});
